// extracted by mini-css-extract-plugin
export default {"acknow":"Acknow_acknow__gaVlV","img":"Acknow_img__yG3zM"};